/* global React, ReactDOM, Shell, Dashboard, SectionTitle, Card, EmptyState, Button, Field, Input, Icon, LoginLanguageSwitch, toast */
// ============================================================
// PLUMME 2.0 — App root + routing
// ============================================================
const ROUTE_TITLES={superplumma:'SuperPlumma',
  hjem:'Hjem',faktura:'Nytt salg',fakturaliste:'Fakturaliste',kunder:'Kunder',produkter:'Produkter',prosjekter:'Prosjekter',
  aiautopilot:'AI Regnskapsfører',aiinnsikt:'AI Rådgiver',
  kjopsoversikt:'Purchases',nyttkjop:'Betalt kjøp',fripostering:'Fri postering',allebilag:'Transaksjoner',transaksjon:'Transaksjon',leverandorer:'Leverandører',eiendeler:'Eiendeler',
  innsendinger:'Innsendinger',innboks:'Innboks',dokumentasjon:'Dokumentasjon',kjorebok:'Kjørebok',bank:'Bank',innstillinger:'Innstillinger',
  annetsalg:'Annet salg',abonnement:'Avtaler',dagsoppgjor:'Dagsoppgjør',resultatregnskap:'Resultatregnskap',saldobalanse:'Saldobalanse',
  lonn:'Lønn',skattemelding:'Skattemelding',arsavslutning:'Årsavslutning',arsregnskap:'Årsregnskap','arsavslutning-kontoplan':'Kontoplan','arsavslutning-aksjekapital':'Aksjekapital','arsavslutning-kontanter':'Mynter og sedler','arsavslutning-mva-kontoer':'Rydd opp i MVA-kontoene','arsavslutning-pensjon':'Pensjonsbetaling (OTP)','arsavslutning-kjop':'Kjøp og leverandørgjeld','arsavslutning-salg':'Salg','arsavslutning-varelager':'Varelager','arsavslutning-periodiseringer':'Riktig år og mulige krav',varelager:'Varelager','arsavslutning-leverandorgjeld':'Leverandørgjeld','arsavslutning-kundefordringer':'Kundefordringer og tap','arsavslutning-eiendeler':'Eiendeler og avskrivninger','arsavslutning-lonn':'Lønnsavstemming','arsavslutning-egenkapital':'Egenkapital og resultat','arsavslutning-sluttkontroll':'Samlet sluttkontroll',
  minside:'Min side',ansattportal:'Ansattportal',aktivitetslogg:'Aktivitetslogg',support:'Support',
  privatokonomi:'Privatøkonomi',investeringer:'Investeringer',
};
window.ROUTE_TITLES = ROUTE_TITLES;
// Oversatt sidetittel. ROUTE_TITLES beholdes som norsk kildeliste og fallback.
const routeTitle = (route) => t(PlummeI18n.keyFor('route', route, 'route'), ROUTE_TITLES[route] || route);
window.routeTitle = routeTitle;
// ui.jsx publishes shared UI components on window. Referencing ToastHost as a
// cross-script lexical binding is unreliable when Vite evaluates classic
// scripts separately on a fresh page load, so resolve it at render time.
function AppToastHost(){
  const Host = window.ToastHost;
  return Host ? <Host/> : null;
}
const ROUTE_COMPONENTS={
  hjem:'Dashboard',faktura:'FakturaPage',fakturaliste:'FakturalistePage',dagsoppgjor:'Dagsoppgjor',kunder:'KunderPage',produkter:'ProdukterPage',prosjekter:'ProsjekterPage',
  superplumma:'SuperPlummaWorkspacePage',aiautopilot:'AiAutopilotPage',aiinnsikt:'AiInnsiktPage',
  kjopsoversikt:'PurchaseOverviewPage',nyttkjop:'NyttKjopPage',fripostering:'FriPosteringPage',allebilag:'AlleBilagPage',transaksjon:'TransactionDetailPage',leverandorer:'LeverandorerPage',
  eiendeler:'EiendelerPage',investeringer:'InvestmentsPage',innsendinger:'InnsendingerPage',innboks:'InnboksPage',dokumentasjon:'InnboksPage',kjorebok:'KjorebokPage',
  bank:'BankPage',innstillinger:'InnstillingerPage',
  regnskapsforer:'RegnskapsforerShell',annetsalg:'AnnetSalgPage',abonnement:'AbonnementPage',
  saldobalanse:'SaldobalansePage',resultatregnskap:'ResultatregnskapPage',lonn:'LonnPage',budsjett:'BudsjettPage',
  skattemelding:'SkattemeldingPage',arsavslutning:'ArsavslutningPage',arsregnskap:'ArsregnskapPage','arsavslutning-kontoplan':'YearClosingChartAccountsPage','arsavslutning-aksjekapital':'YearClosingShareCapitalPage','arsavslutning-kontanter':'YearClosingCashCountPage','arsavslutning-mva-kontoer':'YearClosingVatCleanupPage','arsavslutning-pensjon':'YearClosingPensionPage','arsavslutning-kjop':'YearClosingPurchasesPage','arsavslutning-salg':'YearClosingSalesPage','arsavslutning-varelager':'YearClosingInventoryPage','arsavslutning-periodiseringer':'YearClosingPeriodisationPage',varelager:'YearClosingInventoryPage','arsavslutning-leverandorgjeld':'YearClosingPayablesPage','arsavslutning-kundefordringer':'YearClosingReceivablesPage','arsavslutning-eiendeler':'YearClosingFixedAssetsPage','arsavslutning-lonn':'YearClosingPayrollReviewPage','arsavslutning-egenkapital':'YearClosingEquityReviewPage','arsavslutning-sluttkontroll':'YearClosingFinalReviewPage',
  minside:'MinSidePage',ansattportal:'AnsattPortalPage',aktivitetslogg:'AktivitetsloggPage',support:'SupportTicketsPage',
  privatokonomi:'PrivatOkonomiPage',
};
// Byraaflatens klientfaner rendrer de samme sidene i sitt eget skall og slar opp
// rute -> komponent her. Se src/pages/regnskapsforer-klientflate.jsx.
window.PLUMME_ROUTE_COMPONENTS=ROUTE_COMPONENTS;
const isPersonalFinanceClient = (backend, businessId) => (backend?.memberships || []).some((membership) =>
  membership.businessId === businessId && (membership.clientType === 'personal' || membership.privateEconomy === true)
);
function Placeholder({route}){
  return <div><SectionTitle>{routeTitle(route)}</SectionTitle>
    <Card><EmptyState acc="doc" title={t('app.placeholder.title')} text={t('app.placeholder.text')} /></Card></div>;
}
// --- persistence helpers (localStorage-backed) ---
const LS = {
  get(k, d){ try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
  set(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
};
const localDayKey = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
// ---------------------------------------------------------------- AI-jobber

// Kvitteringen for en handling AI Regnskapsforer har bestilt.
//
// Sendingen kjorer i Functions, ikke i fanen: «kjores selv om du lukker siden»
// er sant om selve utforingen. Men lytteren som fortalte hvordan det gikk laa
// paa AI-siden, og ble revet ned i det brukeren gikk videre. Da naadde svaret
// bare den som ble staaende og ventet — gikk du til fakturalisten for aa se
// etter fakturaen, fikk du aldri vite at den stoppet paa en manglende adresse.
// Fakturaen sto bare fortsatt usendt, uten en grunn noe sted.
//
// Lytteren hoerer derfor til appen, ikke til siden. Den lever hele okten, og
// kvitteringen kommer der brukeren er.
const AUTOPILOT_JOB_SEEN_KEY = 'plumme-autopilot-jobs-seen';
// Kvitteringene som allerede er gitt, slik at et sidebytte eller en ny lasting
// ikke gjentar dem. Eldre enn et dogn kastes — jobbene er da uansett ute av
// lytterens vindu.
const AUTOPILOT_JOB_SEEN_MAX_AGE_MS = 24 * 3600 * 1000;
// Lukket brukeren fanen mens jobben stod paa, skal svaret fortsatt komme naar de
// er tilbake. Men bare mens det er nytt: en jobb fra i gaar er historikk, og en
// toast om den ville vaert stoy ved hver innlasting.
const AUTOPILOT_JOB_FRESH_MS = 10 * 60 * 1000;
const autopilotJobFinishedAt = (job) => {
  const parsed = Date.parse(String(job?.finishedAt || ''));
  return Number.isNaN(parsed) ? 0 : parsed;
};
const autopilotJobReceiptText = (job) => {
  if (job.status === 'failed') return [job.error || t('ap.job.failed', 'Handlingen ble ikke gjennomført.'), 'error'];
  const booked = Number(job.bookedCount) || 0;
  const skipped = Number(job.skippedCount) || 0;
  return skipped
    ? [t('ap.job.donePartial', '{{booked}} utført · {{skipped}} ble ikke utført og må følges opp.', { booked, skipped }), 'info']
    : [t('ap.job.done', '{{booked}} utført.', { booked }), 'success'];
};
function useAutopilotJobReceipts(activeBusinessId) {
  useEffect(() => {
    if (!window.PlummeBackend?.watchAutopilotJobs) return undefined;
    const seen = { ...(LS.get(AUTOPILOT_JOB_SEEN_KEY, {}) || {}) };
    const remember = (jobId, at) => { seen[jobId] = at; };
    const persist = () => {
      const cutoff = Date.now() - AUTOPILOT_JOB_SEEN_MAX_AGE_MS;
      LS.set(AUTOPILOT_JOB_SEEN_KEY, Object.fromEntries(Object.entries(seen).filter(([, at]) => at > cutoff)));
    };
    const stop = window.PlummeBackend.watchAutopilotJobs((jobs) => {
      jobs.forEach((job) => {
        if (job.status !== 'done' && job.status !== 'failed') return;
        if (seen[job.id]) return;
        const finishedAt = autopilotJobFinishedAt(job);
        remember(job.id, finishedAt || Date.now());
        // Gammelt nytt kvitteres ut i stillhet. Uten dette ville hele
        // jobbhistorikken toastet forste gang lytteren startet.
        if (finishedAt && Date.now() - finishedAt > AUTOPILOT_JOB_FRESH_MS) return;
        const [message, tone] = autopilotJobReceiptText(job);
        toast(message, tone);
      });
      persist();
    });
    return () => { if (typeof stop === 'function') stop(); };
  }, [activeBusinessId]);
}

const trialDismissKey = (backend) => 'plumme-trial-dismissed-' + (backend?.user?.uid || 'local');
const toDateValue = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value.seconds === 'number') return new Date(value.seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
const daysUntil = (value) => {
  const date = toDateValue(value);
  if (!date) return null;
  return Math.max(0, Math.ceil((date.getTime() - Date.now()) / 86400000));
};
const trialBannerInfo = (backend) => {
  const billing = backend?.billing || null;
  if (billing?.status !== 'trialing') return null;
  const trialEnd = toDateValue(billing.trialEndsAt);
  if (!trialEnd || trialEnd.getTime() <= Date.now()) return null;
  const daysLeft = daysUntil(billing.trialEndsAt);
  return {
    daysLeft,
    progress: daysLeft == null ? 40 : Math.max(4, Math.min(100, Math.round(((30 - Math.min(daysLeft, 30)) / 30) * 100))),
  };
};
const shouldShowTrialBanner = (backend) => !!trialBannerInfo(backend) && LS.get(trialDismissKey(backend), '') !== localDayKey();
// Per-client namespaced store for editable demo data. The Firebase adapter defines
// window.clientStore first when configured, so keep this as a static/offline fallback.
if (!window.clientStore) {
  window.clientStore = {
    get(client, key, d){ return LS.get('plumme-data-' + client + '-' + key, d); },
    set(client, key, v){ LS.set('plumme-data-' + client + '-' + key, v); },
  };
}
const normalizeStoredRoute = (route) => (route === 'logginn' || !ROUTE_COMPONENTS[route] ? 'hjem' : route);
// URL-en vinner over den lagrede ruta ved oppstart: apner du en delt lenke eller et
// bokmerke, skal du lande der — ikke pa sida du sist var innom i en annen fane.
const initialRoute = () => {
  const fromUrl = window.PlummeAppRoute?.routeForPath?.(window.location.pathname);
  return normalizeStoredRoute(fromUrl || LS.get('plumme-route', 'hjem'));
};
// Undersida er en del av adressen, sa `/ansatte/lonn/ansatte` apner rett arbeidsflate
// i et nytt vindu. Star vi et annet sted, gjelder sist valgte underside som for.
const initialSubPage = (route, fallback) => {
  const url = window.PlummeAppRoute?.resolvePath?.(window.location.pathname);
  return url && url.route === route && url.subPage ? url.subPage : fallback;
};
// Innstillinger-fanen lagres rått av `settings.jsx` (ikke JSON), sa den leses rått her.
const storedSettingsTab = () => {
  try { return localStorage.getItem('plumme-innstillinger-tab') || 'foretak'; } catch (error) { return 'foretak'; }
};
function AuthGate({ backend }) {
  const householdInvitePending = Boolean(window.PlummeHouseholdInvite?.current?.());
  const businessInviteId = window.PlummeBusinessInvite?.current?.() || '';
  const businessInvitePending = Boolean(businessInviteId);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [resetEmail, setResetEmail] = useState('');
  const [view, setView] = useState('login');
  const [busy, setBusy] = useState(false);
  const [resetBusy, setResetBusy] = useState(false);
  const [error, setError] = useState('');
  React.useEffect(() => { if (businessInvitePending) { setEmail(''); setPassword(''); } }, [businessInviteId]);
  const sub = view === 'forgot'
    ? t('auth.sub.forgot')
    : view === 'sent'
      ? t('auth.sub.sent')
      : view === 'signup'
        ? t('auth.sub.signup')
        : t('auth.sub.default');
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await window.PlummeBackend.signIn(email.trim(), password);
    } catch (err) {
      setError(err?.message || t('auth.error.signIn'));
    } finally {
      setBusy(false);
    }
  };
  const forgot = async (e) => {
    e.preventDefault();
    setResetBusy(true);
    setError('');
    try {
      const target = (resetEmail || email).trim();
      await window.PlummeBackend.sendPasswordResetEmail(target);
      setResetEmail(target);
      setView('sent');
    } catch (err) {
      setError(err?.message || t('auth.error.reset'));
    } finally {
      setResetBusy(false);
    }
  };
  const openForgot = () => {
    setError('');
    setResetEmail((resetEmail || email).trim());
    setView('forgot');
  };
  const openLogin = () => {
    setError('');
    setView('login');
  };
  const openSignup = () => {
    setError('');
    if (businessInvitePending) { setEmail(''); setPassword(''); }
    setView('signup');
  };
  const signup = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const onboardingMode = businessInvitePending ? 'regnskapsforer' : householdInvitePending ? 'privat' : 'choose';
    // Store the intended post-verification destination before Firebase changes
    // auth state. The employee-portal gate renders on that auth event and must be
    // able to distinguish self-registration from an employee invitation.
    localStorage.setItem('plumme-open-onboarding-after-signup', onboardingMode);
    try {
      await window.PlummeBackend.signUp({ email: email.trim(), password, displayName });
    } catch (err) {
      if (!window.PlummeBackend?.user) localStorage.removeItem('plumme-open-onboarding-after-signup');
      setError(err?.message || t('auth.error.signUp'));
    } finally {
      setBusy(false);
    }
  };
  return <div className="app login-shell">
    <div className="login-wrap">
      <div className="login-card">
        <LoginLanguageSwitch /><div className="login-brand">
          <img src={view === 'forgot' ? 'src/img/PlummaConfused-320.webp' : 'src/img/PlummaWave-320.webp'} alt="" className="login-plum" />
          <div className="t-display login-title">Plumme</div>
          <div className="t-sm muted login-sub">{sub}</div>
        </div>
        {error && <div className="alert alert-error"><span className="alert-ico"><Icon name="alertTri" size={18} /></span><span>{error}</span></div>}
        {backend.error && !error && <div className="alert alert-warning"><span className="alert-ico"><Icon name="alertTri" size={18} /></span><span>{backend.error}</span></div>}
        {householdInvitePending && <div className="alert alert-info"><span className="alert-ico"><Icon name="users" size={18} /></span><span>{t('auth.invite.household')}</span></div>}
        {businessInvitePending && <div className="alert alert-info"><span className="alert-ico"><Icon name="building" size={18} /></span><span>{t('auth.invite.business')}</span></div>}

        {view === 'login' && <React.Fragment>
          <form onSubmit={submit}>
            <Field label={t('auth.email')} className="mt-16"><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('auth.emailPlaceholder')} autoComplete={businessInvitePending ? 'off' : 'email'} /></Field>
            <Field label={t('auth.password')} className="mt-12"><Input type="password" passwordToggle value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" /></Field>
            <div className="row between" style={{ marginTop: 10 }}>
              <label className="row gap-8 t-sm" style={{ fontWeight: 600, cursor: 'pointer' }}><input type="checkbox" defaultChecked /> {t('auth.remember')}</label>
              <button type="button" className="t-sm login-inline-link" onClick={openForgot}>{t('auth.forgot')}</button>
            </div>
            <Button type="submit" className="btn-block btn-lg" icon="arrowUpRight" disabled={busy || !email || !password} style={{ marginTop: 18 }}>{busy ? t('auth.signingIn') : t('auth.signIn')}</Button>
          </form>
          <div className="login-foot t-sm muted">{t('auth.noAccount')} <button type="button" className="login-inline-link" onClick={openSignup}>{t('auth.createAccount')}</button></div>
        </React.Fragment>}

        {view === 'signup' && <form onSubmit={signup}>
          <Field label={t('auth.name')} className="mt-16"><Input value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder={t('auth.namePlaceholder')} autoComplete="name" /></Field>
          <Field label={t('auth.email')} className="mt-12"><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('auth.emailPlaceholder')} autoComplete={businessInvitePending ? 'off' : 'email'} /></Field>
          <Field label={t('auth.password')} className="mt-12"><Input type="password" passwordToggle value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t('auth.passwordMin')} autoComplete="new-password" /></Field>
          <Button type="submit" className="btn-block btn-lg" icon="arrowUpRight" disabled={busy || !email || password.length < 6} style={{ marginTop: 18 }}>{busy ? t('auth.creating') : t('auth.createAccount')}</Button>
          <button type="button" className="login-back" onClick={openLogin}><Icon name="arrowLeft" size={15} />{t('auth.backToLogin')}</button>
        </form>}

        {view === 'forgot' && <form onSubmit={forgot}>
          <p className="t-sm login-copy">{t('auth.forgotCopy')}</p>
          <Field label={t('auth.email')} className="mt-14"><Input type="email" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} placeholder={t('auth.emailPlaceholder')} autoComplete="email" /></Field>
          <Button type="submit" className="btn-block btn-lg" icon="send" disabled={resetBusy || !resetEmail.trim()} style={{ marginTop: 18 }}>{resetBusy ? t('auth.sending') : t('auth.sendResetLink')}</Button>
          <button type="button" className="login-back" onClick={openLogin}><Icon name="arrowLeft" size={15} />{t('auth.backToLogin')}</button>
        </form>}

        {view === 'sent' && <div className="login-sent">
          <div className="login-sent-ico"><Icon name="send" size={26} /></div>
          {/* Deler på {email}-plassholderen slik at adressen beholder uthevingen uansett ordstilling. */}
          <p className="t-body login-sent-copy">{(() => { const parts = t('auth.sentCopy').split('{email}'); return <React.Fragment>{parts[0]}<b>{resetEmail}</b>{parts[1] || ''}</React.Fragment>; })()}</p>
          <Button className="btn-block btn-lg" icon="arrowLeft" style={{ marginTop: 18 }} onClick={openLogin}>{t('auth.backToLogin')}</Button>
          <button type="button" className="login-back" onClick={openForgot}>{t('auth.wrongEmail')}</button>
        </div>}
      </div>
    </div>
  </div>;
}

function BackendLoading({ translationKey = 'app.loading' }) {
  const loadingImage = (window.__resources && window.__resources.superPlummaLoadingBoot) || 'src/img/superPlummaLoading-360.webp';
  const logoImage = (window.__resources && window.__resources.plummeLogoNew) || 'src/img/plummeLogoNew-480.webp';
  return <div
    className="app"
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 14,
      padding: 24,
      background: 'var(--canvas-top)',
      fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
    }}
  >
    <img src={loadingImage} alt="" style={{ width: 180, height: 'auto', animation: '__bob 2.4s ease-in-out infinite' }} />
    <img src={logoImage} alt="Plumme" style={{ width: 84, height: 'auto', display: 'block' }} />
    <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--muted)' }}>{t(translationKey)}</div>
  </div>;
}

function NoBusiness({ backend }) {
  const businessInviteId = window.PlummeBusinessInvite?.current?.() || '';
  const hasBusinessInvite = Boolean(businessInviteId);
  React.useEffect(() => {
    if (backend.user?.emailVerified !== true) return;
    if (!localStorage.getItem('plumme-open-onboarding-after-signup')) return;
    const mode = localStorage.getItem('plumme-open-onboarding-after-signup');
    localStorage.removeItem('plumme-open-onboarding-after-signup');
    const inviteId = mode === 'regnskapsforer' ? window.PlummeBusinessInvite?.current?.() : window.PlummeHouseholdInvite?.current?.();
    const timer = window.setTimeout(() => window.showOnboarding?.(mode === 'choose' ? undefined : mode, { inviteId }), 250);
    return () => window.clearTimeout(timer);
  }, [backend.user?.emailVerified]);
  return <div className="app" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}><Card style={{ width: 'min(520px, 100%)' }}>
    <div className="row gap-14" style={{ alignItems: 'center' }}><div><h1 className="t-h2">{hasBusinessInvite ? 'Du har en klientinvitasjon' : t('app.nobusiness.title')}</h1><div className="t-sm muted">{hasBusinessInvite ? 'Bruk e-postadressen invitasjonen ble sendt til. Hvis du er logget inn med en annen konto, logg ut og inn med riktig adresse.' : t('app.nobusiness.text')}</div></div></div>
    {backend.error && <div className="alert alert-warning mt-16"><span className="alert-ico"><Icon name="alertTri" size={18} /></span><span>{backend.error}</span></div>}
    <div className="row gap-10 mt-16" style={{ flexWrap: 'wrap' }}>{hasBusinessInvite ? <React.Fragment>
      <Button icon="building" onClick={() => window.showOnboarding?.('regnskapsforer', { inviteId: businessInviteId })}>{t('r1e.app.viewClientInvite')}</Button><Button variant="secondary" onClick={() => window.PlummeBackend?.signOut?.()}>{t('app.nobusiness.signOut')}</Button>
    </React.Fragment> : <React.Fragment>
      <Button icon="sparkle" onClick={() => window.showOnboarding?.('privat', { inviteId: window.PlummeHouseholdInvite?.current?.() })}>{t('r1e.app.createPersonal')}</Button><Button variant="secondary" icon="building" onClick={() => window.showOnboarding?.('foretak')}>{t('app.nobusiness.create')}</Button><Button variant="secondary" icon="users" onClick={() => window.showOnboarding?.('regnskapsforer', { inviteId: window.PlummeBusinessInvite?.current?.() })}>{t('r1e.app.imAccountant')}</Button>
      {(window.PlummeBackend?.firmMemberships || []).length ? <Button variant="secondary" icon="building" onClick={() => window.dispatchEvent(new CustomEvent('plumme-open-firm-surface'))}>{t('app.nobusiness.openFirm', 'Åpne regnskapsbyrået')}</Button> : null}<Button variant="secondary" onClick={() => window.PlummeBackend.signOut()}>{t('app.nobusiness.signOut')}</Button>
    </React.Fragment>}</div>
  </Card></div>;
}
// Språkbytte må males i hele treet. Ingen komponent her er memoisert, så en
// state-bump i rota re-rendrer alt uten å remounte og miste sidestate.
function useLocaleVersion(){
  const [version,setVersion]=useState(0);
  useEffect(()=>{
    const bump=()=>setVersion((value)=>value+1); window.addEventListener('plumme-help-articles-loaded',bump); // Firestore help articles landed
    // Katalogene for et spraak lastes forst naar spraaket er i bruk. Norsk ligger
    // fortsatt som vanlige <script> i index.html og er alltid til stede, saa dette
    // er et no-op for standardspraaket. Engelsk hentes her — ved oppstart hvis det
    // er lagret fra sist, og ellers naar brukeren bytter.
    //
    // Fram til katalogen er inne slaar `t()` tilbake paa norsk (FALLBACK_LOCALES),
    // ikke paa raa noekler. `bump` maler treet paa nytt naar den har landet.
    const ensureCatalog=()=>{
      const pending=window.PlummePageLoader?.loadLocale(PlummeI18n.getLocale());
      if(pending&&typeof pending.then==='function') pending.then(bump);
    };
    const sync=()=>{ ensureCatalog(); bump(); };
    ensureCatalog();
    window.addEventListener(PlummeI18n.CHANGE_EVENT,sync);
    return ()=>{window.removeEventListener(PlummeI18n.CHANGE_EVENT,sync);window.removeEventListener('plumme-help-articles-loaded',bump);};
  },[]);
  return version;
}
window.useLocaleVersion = useLocaleVersion;
function App(){
  const localeVersion = useLocaleVersion();
  if (window.InvoicePublicView?.parseCurrentPath?.()) {
    return <React.Fragment><window.InvoicePublicView /><AppToastHost/></React.Fragment>;
  }
  const backend = window.PlummeBackend ? window.PlummeBackend.useBackend() : { loading: false, appState: null };
  const activeBusinessId = backend.activeBusinessId || 'local';
  const [client,setClientState]=useState(()=>activeBusinessId || LS.get('plumme-client','joda')), [route,setRouteState]=useState(initialRoute), routeRef=useRef(route); routeRef.current=route;
  const support=window.useSupportRouteState(); // Support sub-page + open article, mirrored in the address
  const setRoute=React.useCallback((nextRoute)=>{window.PlummeAppRoute?.markYearClosingChecklistReturn?.(routeRef.current,nextRoute);if(nextRoute==='support'&&routeRef.current!=='support')support.enterRoute();setRouteState(nextRoute);},[]);
  const [year,setYearState]=useState(()=>LS.get('plumme-year-'+activeBusinessId,2026));
  const [lonnPage,setLonnPage]=useState(()=>initialSubPage('lonn',LS.get('plumme-lonnpage','employees'))), [transactionPage,setTransactionPage]=useState(()=>initialSubPage('allebilag',LS.get('plumme-transaction-page','bilag')));
  // Innstillinger-fanen eies av `settings.jsx`. App-rota holder en kopi fordi den star
  // i adressen, og de to holdes i takt med `plumme-settings-tab`-eventet begge veier.
  const [settingsTab,setSettingsTab]=useState(()=>initialSubPage('innstillinger',storedSettingsTab()));
  const [rfSubPage,setRfSubPage]=useState(()=>initialSubPage('regnskapsforer','klientoversikt'));
  // Satt naar en byraabruker uten eget foretak forlater byraaflaten med vilje.
  const [firmSurfaceDismissed,setFirmSurfaceDismissed]=useState(false);
  const [collapsed,setCollapsed]=useState(()=>LS.get('plumme-collapsed',false));
  const [trial,setTrial]=useState(()=>shouldShowTrialBanner(backend));
  const trialInfo=trialBannerInfo(backend);
  const [,setPageRegistryVersion]=useState(0);
  const closeTrial = () => {
    LS.set(trialDismissKey(backend), localDayKey());
    setTrial(false);
  };
  const openSubscriptionSettings = () => {
    setRoute('innstillinger');
    setSettingsTab('abonnement');
    window.dispatchEvent?.(new CustomEvent('plumme-settings-tab', { detail: 'abonnement' }));
  };
  useEffect(() => {
    if (activeBusinessId && activeBusinessId !== client) setClientState(activeBusinessId);
  }, [activeBusinessId]);
  // Kvitteringen for bestilte AI-handlinger folger okten, ikke ruta.
  useAutopilotJobReceipts(activeBusinessId);
  // Onboardingen for regnskapsforere apner byraaflaten herfra. Den er en rute i samme
  // app, ikke en egen palogging — se src/pages/regnskapsforer.jsx.
  useEffect(() => {
    const openFirmSurface = () => { setFirmSurfaceDismissed(false); setRoute('regnskapsforer'); };
    window.addEventListener('plumme-open-firm-surface', openFirmSurface);
    return () => window.removeEventListener('plumme-open-firm-surface', openFirmSurface);
  }, []);
  useEffect(() => {
    setTrial(shouldShowTrialBanner(backend));
  }, [backend.user?.uid, backend.billing?.status, backend.billing?.trialEndsAt]);
  const previousUserId = useRef(backend.user?.uid || '');
  useEffect(() => {
    const currentUserId = backend.user?.uid || '';
    const shouldResetRoute = window.PlummeSessionRoute?.shouldResetRouteForUser?.({
      previousUserId: previousUserId.current, currentUserId, route,
    });
    if (shouldResetRoute) {
      setRoute('hjem');
    }
    if (currentUserId) previousUserId.current = currentUserId;
  }, [backend.user?.uid]);
  const setClient = (nextClient) => {
    setClientState(nextClient);
    if (window.PlummeBackend && nextClient !== 'local') window.PlummeBackend.setActiveBusinessId(nextClient);
  };
  useEffect(() => {
    const openPrivate = (event) => {
      const businessId = event.detail?.businessId;
      if (businessId) setClient(businessId);
      setRoute('privatokonomi');
    };
    window.addEventListener('plumme-private-created', openPrivate);
    return () => window.removeEventListener('plumme-private-created', openPrivate);
  }, []);
  useEffect(() => {
    const openBusiness = (event) => { const businessId = event.detail?.businessId; if (businessId) setClient(businessId); const accountingStartYear=Number(event.detail?.year); if(Number.isInteger(accountingStartYear))setYear(accountingStartYear); setRoute('hjem'); };
    const events = ['plumme-business-invite-accepted', 'plumme-business-created'];
    events.forEach((eventName) => window.addEventListener(eventName, openBusiness));
    return () => events.forEach((eventName) => window.removeEventListener(eventName, openBusiness));
  }, []);
  const setYear = (nextYear) => {
    setYearState(nextYear);
    window.PlummeBackend?.setLocalActiveYear?.(nextYear);
  };
  useEffect(() => {
    if (backend.appState) window.PlummeBackend?.setLocalActiveYear?.(year);
  }, [activeBusinessId, Boolean(backend.appState)]);
  // expose navigation for global consumers (SuperSearch, help articles)
  useEffect(()=>window.PlummeGlobalSearch.installNavigation(nextRoute=>setRoute(normalizeStoredRoute(nextRoute)),setYear),[]);
  // persist client selection
  useEffect(()=>{ LS.set('plumme-client',client); },[client]);
  // when the client changes, load that client's saved year
  const prevClient=useRef(client);
  useEffect(()=>{
    if(prevClient.current!==client){
      setYear(LS.get('plumme-year-'+client,2026));
      prevClient.current=client;
    }
  },[client]);
  // persist year per-client + remember UI state
  useEffect(()=>{ LS.set('plumme-year-'+client,year); },[year,client]);
  useEffect(()=>{ LS.set('plumme-route',route); window.PlummeJournalDemand.route(route); },[route]);
  // Adressen folger ruta, undersida og foretaket. Forste synk erstatter adressen i
  // stedet for a legge til en historikk-post — sida du allerede star pa skal ikke bli
  // et steg a ga tilbake fra. Ovrige query-parametre beholdes bare pa den forste
  // (invitasjonsparametre horer ikke med videre til neste side).
  const urlSynced=useRef(false);
  const routeSubPage=route==='lonn'?lonnPage:route==='allebilag'?transactionPage:route==='innstillinger'?settingsTab:route==='support'?support.page:'';
  useEffect(()=>{
    const routeApi=window.PlummeAppRoute;
    if(!routeApi) return;
    const first=!urlSynced.current;
    const businessId=backend.configured?(backend.activeBusinessId||''):'',transactionTarget=route==='transaksjon'?window.__plummeTransactionRouteTarget:null;
    const target=transactionTarget?.voucherId
      ? routeApi.urlForVoucher(transactionTarget.voucherId,{businessId,year:transactionTarget.year})
      : routeApi.urlForRoute(route,{subPage:routeSubPage,businessId,keepSearch:first?support.firstSearch(route,window.location.search):support.keepSearch(route)});
    if(!target) return;
    if(transactionTarget) window.__plummeTransactionRouteTarget=null;
    urlSynced.current=true;
    if(routeApi.sameUrl(window.location.pathname+window.location.search,target)) return;
    window.history[support.historyMethod(first)]({plummeRoute:route},'',target+(first?window.location.hash:''));
  },[route,routeSubPage,support.articleId,backend.activeBusinessId,backend.configured]);
  // Fram/tilbake i nettleseren. Ukjent sti (f.eks. en offentlig fakturalenke) rores ikke.
  useEffect(()=>{
    const onPop=()=>{
      const routeApi=window.PlummeAppRoute;
      const next=routeApi?.resolvePath?.(window.location.pathname);
      if(!next) return;
      setRoute(normalizeStoredRoute(next.route));
      if(next.subPage&&next.route==='lonn') setLonnPage(next.subPage); if(next.subPage&&next.route==='allebilag') setTransactionPage(next.subPage); if(next.route==='support') support.syncFromLocation(next);
      if(next.subPage&&next.route==='innstillinger'){
        setSettingsTab(next.subPage);
        window.dispatchEvent?.(new CustomEvent('plumme-settings-tab',{detail:next.subPage}));
      }
      // Gikk vi tilbake til et annet foretak, skal fanen folge med dit.
      const wanted=routeApi.businessFromSearch(window.location.search);
      if(wanted&&wanted!==backend.activeBusinessId) setClient(wanted);
    };
    window.addEventListener('popstate',onPop);
    return ()=>window.removeEventListener('popstate',onPop);
  },[backend.activeBusinessId]);
  // Innstillinger-sida eier fanen sin; her holdes kopien i adressen i takt med den.
  useEffect(()=>{
    const onTab=(event)=>{ if(event?.detail) setSettingsTab(event.detail); };
    window.addEventListener('plumme-settings-tab',onTab);
    return ()=>window.removeEventListener('plumme-settings-tab',onTab);
  },[]);
  // Fanetittelen skiller vinduene fra hverandre nar man jobber i flere samtidig.
  useEffect(()=>{
    document.title=routeTitle(route)+' · Plumme';
  },[route,localeVersion]);
  useEffect(() => {
    if (isPersonalFinanceClient(backend, client) && !['privatokonomi', 'minside', 'ansattportal', 'logginn'].includes(route)) {
      setRoute('privatokonomi');
    }
  }, [client, route, backend.memberships]);
  useEffect(()=>{ LS.set('plumme-lonnpage',lonnPage); },[lonnPage]); useEffect(()=>{ LS.set('plumme-transaction-page',transactionPage); },[transactionPage]);
  useEffect(()=>{ LS.set('plumme-collapsed',collapsed); },[collapsed]);
  useEffect(()=>{const m=document.querySelector('.main');if(m)m.scrollTop=0;window.scrollTo(0,0);},[route]);
  // The firm surface is lazy (data-routes="regnskapsforer"). A firm-only user sees it without being on that route, so its load is started from render below; this re-renders once it has registered or failed.
  useEffect(()=>{const onSettled=(event)=>{if(event?.detail?.route==='regnskapsforer')setPageRegistryVersion((v)=>v+1);};['plumme-page-registered','plumme-page-load-error'].forEach((name)=>window.addEventListener(name,onSettled));return ()=>['plumme-page-registered','plumme-page-load-error'].forEach((name)=>window.removeEventListener(name,onSettled));},[]);
  useEffect(()=>{
    const componentName=isPersonalFinanceClient(backend,client)&&route==='minside'?'PrivatOkonomiPage':ROUTE_COMPONENTS[route];
    if(!componentName||window[componentName]&&!window.PlummePageLoader?.hasRoute(route)) return undefined;
    let stopped=false;
    const refresh=()=>{ if(!stopped&&window[componentName]) setPageRegistryVersion((v)=>v+1); };
    // The timers are only a fallback for a missing loader; once every route script has run they would just re-render the whole app again.
    window.PlummePageLoader?.loadRoute(route).then(()=>{refresh();timers.forEach(clearTimeout);}).catch(()=>setPageRegistryVersion((v)=>v+1)); window.addEventListener('plumme-page-registered',refresh);
    const timers=[100,350,900,1600].map((ms)=>setTimeout(refresh,ms));
    return ()=>{
      stopped=true;
      window.removeEventListener('plumme-page-registered',refresh);
      timers.forEach(clearTimeout);
    };
  },[route,client,backend.memberships]);
  // Ansatt uten eget foretak leser aldri app-state: personnelStateReadable blir staaende null.
  const employeePortal=window.PlummeEmployeePortalGate.useEmployeeOnlyPortal(backend,route,setRoute);
  const personnelRouteLoading=backend.configured&&backend.user&&backend.activeBusinessId&&['lonn','ansattportal'].includes(route)&&backend.personnelStateReadable==null;
  if (backend.error && !backend.loading && window.BackendStartupError) return <React.Fragment><window.BackendStartupError backend={backend}/><AppToastHost/></React.Fragment>;
  if (backend.loading || personnelRouteLoading) {
    const translationKey = window.PlummeSessionRoute?.loadingTranslationKey?.({
      route,
      personalFinance: isPersonalFinanceClient(backend, client),
    }) || 'app.loading';
    return <BackendLoading translationKey={translationKey} />;
  }
  if (backend.configured && !backend.user) return <React.Fragment><AuthGate backend={backend} /><AppToastHost/></React.Fragment>;
  // Byraaflaten er et ANNET skall, ikke en side i kundeappen: egen sidebar, egne
  // faner. Den rendres derfor for <Shell>, ikke inne i den.
  //
  // Og for «fant ikke foretak»: en regnskapsforer som akkurat har registrert seg har
  // ingen foretak, og det er nettopp da hen skal kunne opprette byraaet sitt. La
  // sjekken under komme forst, ville byraaflaten vaert umulig aa naa for den som
  // trengte den mest.
  // En byraabruker uten eget foretak — en ansatt regnskapsforer, eller en eier som
  // ikke har tatt inn klienter enna — har ingenting aa vise i kundeappen. Uten dette
  // landet hen paa «fant ikke foretak» ved hver eneste innlogging, med byraaet sitt
  // rett bak en skjerm som sa at ingenting fantes.
  const firmOnlyUser = backend.configured
    && backend.user
    && !backend.activeBusinessId
    && (window.PlummeBackend?.firmMemberships || []).length > 0;
  // ...men hen maa komme ut igjen. Uten dette ville «Tilbake» sendt brukeren rett
  // inn i byraaflaten paa nytt, og veien til aa opprette et eget foretak eller
  // Privatokonomi var stengt.
  const leaveFirmSurface = (nextRoute) => {
    setFirmSurfaceDismissed(true);
    setRoute(nextRoute || 'hjem');
  };
  const firmSurfaceWanted = route === 'regnskapsforer' || (firmOnlyUser && !firmSurfaceDismissed);
  if (firmSurfaceWanted && !window.RegnskapsforerShell && window.PlummePageLoader?.hasRoute('regnskapsforer')) { window.PlummePageLoader.loadRoute('regnskapsforer').catch(()=>{}); return <BackendLoading translationKey="app.loading"/>; }
  if (firmSurfaceWanted && window.RegnskapsforerShell) {
    return <React.Fragment>
      <window.RegnskapsforerShell subPage={rfSubPage} setSubPage={setRfSubPage} setRoute={leaveFirmSurface} setClient={setClient} />
      <AppToastHost/>
    </React.Fragment>;
  }

  if (employeePortal.active) return <React.Fragment><window.PlummeEmployeePortalGate.EmployeePortalSurface gate={employeePortal} Loading={BackendLoading} setRoute={setRoute} client={client} setClient={setClient} /><AppToastHost/></React.Fragment>;
  if (backend.configured && backend.user && !backend.activeBusinessId) return <React.Fragment><NoBusiness backend={backend} />{window.BusinessInviteGate && <window.BusinessInviteGate backend={backend} />}{window.FirmInviteGate && <window.FirmInviteGate backend={backend} />}{window.PersonalFinanceHouseholdInviteGate && <window.PersonalFinanceHouseholdInviteGate backend={backend} setClient={setClient} setRoute={setRoute} />}<AppToastHost/>{window.OnboardingLayer && <window.OnboardingLayer/>}</React.Fragment>;
  const privateClientActive=isPersonalFinanceClient(backend,client); const componentName=privateClientActive&&route==='minside'?'PrivatOkonomiPage':ROUTE_COMPONENTS[route];
  const Comp=window[componentName]||null; const routeLoading=window.PlummePageLoader?.hasRoute(route,{codeOnly:!!Comp});
  if(Comp)window.PlummeStartupPerformance?.mark('interactive',{route}); const surface = <React.Fragment>
    <Shell route={route} setRoute={setRoute} year={year} setYear={setYear} collapsed={collapsed} setCollapsed={setCollapsed} trial={trial} trialInfo={trialInfo} setTrial={closeTrial} onUpgradeTrial={openSubscriptionSettings} client={client} setClient={setClient} lonnPage={lonnPage} setLonnPage={setLonnPage} transactionPage={transactionPage} setTransactionPage={setTransactionPage} supportPage={support.page} setSupportPage={support.setPage}>
      {routeLoading?<BackendLoading translationKey="app.loading"/>:Comp?<Comp route={route} setRoute={setRoute} setYear={setYear} year={year} subPage={route==='allebilag'?transactionPage:route==='support'?support.page:lonnPage} setSubPage={route==='allebilag'?setTransactionPage:route==='support'?support.setPage:setLonnPage} articleId={support.articleId} setArticleId={support.setArticleId} client={client} setClient={setClient}/>:<Placeholder route={route}/>}
    </Shell>
    <AppToastHost/>
    {window.PersonalFinanceHouseholdInviteGate && <window.PersonalFinanceHouseholdInviteGate backend={backend} setClient={setClient} setRoute={setRoute} />}
    {window.BusinessInviteGate && <window.BusinessInviteGate backend={backend} />}
    {window.FirmEngagementGate && <window.FirmEngagementGate backend={backend} />}
    {window.FirmInviteGate && <window.FirmInviteGate backend={backend} />}
    {window.OnboardingLayer && <window.OnboardingLayer/>}
    {window.StartupProfileGate && <window.StartupProfileGate backend={backend} onOpenWizard={(mode)=>{window.__plummeStartupWizardMode=mode;setRoute('innstillinger');setSettingsTab('regnskap');window.dispatchEvent?.(new CustomEvent('plumme-settings-tab',{detail:'regnskap'}));window.setTimeout(()=>window.dispatchEvent?.(new CustomEvent('plumme-open-startup-wizard',{detail:mode})),0);}}/>}
  </React.Fragment>;
  return !privateClientActive && backend.user ? <InvoiceControl key={`${backend.user.uid}:${activeBusinessId}:${year}`} businessId={activeBusinessId} year={year} route={route} setRoute={setRoute}>{surface}</InvoiceControl> : surface;
}
ReactDOM.createRoot(document.getElementById('root')).render(<App/>);
